// extracted by mini-css-extract-plugin
export var brand = "_2t-9";
export var compact = "_2t-6";
export var extraSmall = "_2t-7";
export var icon = "_2t-0";
export var large = "_2t-4";
export var light = "_2t-1";
export var medium = "_2t-5";
export var outline = "_2t-b";
export var primaryDark = "_2t-a";
export var primaryLight = "_2t-8";
export var primaryModern = "_2t-c";
export var success = "_2t-2";
export var successSolid = "_2t-3";